<template>
    <div class="toolbar" id="kt_toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
             data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
             class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1"> {{ settingText }}</h1>
          <span class="h-20px border-gray-300 border-start mx-4"></span>
          <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
            <div v-for="(bread, key) in breadcrumb" :key="key">
              <div v-if="$can(bread.permission)">
                <li class="breadcrumb-item text-muted" v-if="key + 1 !== breadcrumb.length">
                  <router-link :to="{ name: bread.routeName }" @click.prevent="handleBreadClick(bread)" class="text-muted text-hover-primary">{{ $t(bread.name) }}</router-link>
                  <span class="bullet bg-gray-300 w-5px h-2px mx-2"></span>
                </li>
                <li v-else class="breadcrumb-item text-primary">{{ $t(bread.name) }}</li>
              </div>
            </div>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <div class="m-0">
            <Button v-if="hasBackBtn" icon-class="fas fa-backspace" btn-class="btn-sm" type="cancel" btn-text="back" @click="$router.go(-1)"/>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import i18n from '@/plugins/i18n';
    import Button from "@/components/Button"
    import {mapGetters} from 'vuex'
    import abilities from "@/composables/abilities";

    export default {
      name: "SettingToolBar",
      components: {Button},
      props: {
        hasBackBtn: { type: Boolean, default: true },
        breadcrumb: { type: Array, default: () => {
          return [
            {routeName:"settings", name:"settings.title", permission: [], routePermission: ''},
            {routeName:"settings-events-status", name:"settings.setting_events", permission: [abilities.VIEW_EVENT_SETTINGS], routePermission: ''},
          ]
        }
        },
      },
        data() {
          return {
            url: window.location.href,
            menuItems: [
              {
                routeName: 'settings-events-status',
                title: 'settings.participator_status',
                icon: 'bi bi-circle-square',
                permission: [],
                name: "settings-events-status"
              },
            ]
          };
        },
  
      computed: {
        ...mapGetters('permission', [
          'permissions'
        ]),
        settingText() {
          const url = window.location.pathname;
          if (url.includes('events')) {
            return i18n.global.t('settings.setting_events');
          }
  
          return '';
        }
      },
      methods: {
        handleBreadClick(bread) {
          if(this.permissions.includes(bread.routePermission) || bread.routePermission == null){
            this.$router.push({ name: bread.routeName });
          }else{
            let firstPermittedName = bread.permission.find(permission => this.permissions.includes(permission)) || bread.permission.find(permission => permission === null);
            
            let firstPermittedRoute = this.menuItems.filter(item => 
              item.name == bread.routeName && item.permission && item.permission.includes(firstPermittedName)
            )[0];
            if (firstPermittedRoute) {
              this.$router.push({ name: firstPermittedRoute.routeName });
            }
          }
        }
      }
    }
  </script>
  
  <style scoped>
  
  </style>
  